type Props = {
  hasSources?: boolean;
  onGetStarted: () => void;
};

/** A quiet invitation that keeps the next action inside the message. */
export function PostIdeasEmptyState({
  hasSources = false,
  onGetStarted,
}: Props) {
  return (
    <div className="flex min-h-[168px] items-center justify-center px-5 py-8 sm:py-10">
      <div className="max-w-md text-center">
        <h3 className="text-base font-medium tracking-tight text-foreground">
          {hasSources
            ? "Ready for a little fresh inspiration?"
            : "Fresh suggested posts, every day."}
        </h3>
        <p className="mt-2 text-sm leading-6 text-muted-foreground">
          {hasSources
            ? "No new suggestions right now. "
            : "Suggested posts don’t use credits. Credits are only used when you generate visuals. "}
          <button
            type="button"
            onClick={onGetStarted}
            aria-haspopup="dialog"
            className="rounded-sm font-medium text-brand underline decoration-brand/40 underline-offset-4 transition-colors hover:decoration-brand focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            {hasSources ? "Explore your sources" : "Add your first source"}
          </button>
          {hasSources
            ? " to find your next starting point."
            : " to get started."}
        </p>
      </div>
    </div>
  );
}
